const en = {

    /* Language */
    "lang.ru": "RU",
    "lang.en": "EN",

    /* Menu */
    "menu.dashboard": "Dashboard",
    "menu.game": "Games",
    "menu.player": "Players",
    "menu.studio": "Studios",
    "menu.bonus": "Bonus",
    "menu.message": "Message",
    "menu.transaction": "Transactions",
    "menu.booking": "VIP booking",
    "menu.currency": "Currencies",
    "menu.card": "Cards",
    "menu.dealer": "Dealers",
    "menu.managers": "Managers",
    "menu.operators": "Operators",
    "menu.rsg": "RSG Reports",
    "menu.log": "Logs",
    "menu.more": "More",
    "menu.pitboard": "Pit Board",
    "pitboard.title": "Pit Board",
    "pitboard.subtitle": "Choose a studio and confirm",
    "pitboard.noStudios": "No studios available",
    "pitboard.go": "Open",
    "pitboard.close": "Close",
    "pitboard.error": "Could not open Pit Board",

    /* Header */
    "header.profile": "Profile",
    "header.changePassword": "Change password",
    "header.history": "Login history",
    "header.logout": "Logout",
    "header.notifications": "Notifications",
    "header.logoutTitle": "Log out of the panel?",
    "header.logoutText": "You will have to enter your email and password again to come back",

    /* Access roles */
    "access.superadmin": "Administrator",
    "access.manager": "Manager",
    "access.pitboss": "Pitboss",
    "access.viewer": "Viewer",

    /* Auth */
    "auth.title": "Control Panel",
    "auth.password": "Password",
    "auth.login": "Login",
    "auth.error.emptyEmail": "Enter Email",
    "auth.error.invalidEmail": "Invalid Email format",
    "auth.error.emptyPassword": "Enter password",
    "auth.error.shortPassword": "Password must be at least 8 characters",
    "auth.error.invalidCredentials": "Invalid credentials!",
    "auth.error.userNotFound": "User not found!",
    "auth.error.wrongPassword": "Wrong password!",
    "auth.error.tooManyAttempts": "Too many login attempts! Try later.",
    "auth.error.generic": "Something went wrong! Try later.",

    /* Layout (full-page states) */
    "layout.serverError": "Server error!",
    "layout.serverErrorDesc": "Something went wrong! Try later.",
    "layout.networkError": "Connection error!",
    "layout.networkErrorDesc": "Check your network connection.",
    "layout.noAccess": "No access!",
    "layout.noAccessDesc": "You do not have access to view this data.",
    "layout.invalidKey": "Invalid key!",
    "layout.invalidKeyDesc": "The key seems to be expired! Reload the page or login again.",
    "layout.retry": "Retry",
    "layout.reload": "Reload",
    "layout.empty": "Nothing found!",
    "layout.emptyDesc": "Try again by changing filters.",

    /* Notes */
    "notes.empty": "No notes",
    "notes.title": "Notes",
    "notes.createError": "Failed to create note!",
    "notes.placeholder": "Write a message",

    /* Dashboard notes modal */
    "dshNotes.title": "All notes",
    "dshNotes.subtitle": "Notes of the games you reach",
    "dshNotes.games": "Games",
    "dshNotes.allGames": "All games",
    "dshNotes.searchPlaceholder": "Search by text or author",
    "dshNotes.empty": "No notes yet",
    "dshNotes.nothingFound": "No notes match this filter",
    "dshNotes.network": "Network is unavailable, try later",

    /* DateFilter */
    "filter.selectDate": "Select date",
    "filter.selectDates": "Select dates",
    "filter.cancel": "Cancel",
    "filter.apply": "Apply",
    "filter.title": "Filter",
    "filter.subtitle": "The period and the operators of the game list",
    "filter.period": "Period",
    "filter.today": "Today",
    "filter.week": "7 days",
    "filter.month": "30 days",
    "filter.reload": "Reload the list",
    "filter.operators": "Operators",
    "filter.studios": "Studios",
    "filter.studiosSubtitle": "Only show dealers of the selected studios",
    "filter.studiosEmpty": "Select at least one studio",
    "filter.selectAll": "Select all",
    "filter.deselectAll": "Deselect all",

    /* Pagination */
    "pagination.showing": "Showing",
    "pagination.of": "of",

    /* Cards */
    "cards.empty": "Empty",

    /* Transaction */
    "transaction.title": "Transaction info",
    "transaction.number": "Transaction number",
    "transaction.player": "Player",
    "transaction.name": "Name",
    "transaction.type": "Type",
    "transaction.time": "Time",
    "transaction.amount": "Amount",
    "transaction.status": "Status",
    "transaction.success": "Success",
    "transaction.error": "Error",
    "transaction.result": "Result",

    /* Time */
    "time.today": "Today",
    "time.todayComma": "Today, ",
    "time.yesterday": "Yesterday",
    "time.yesterdayComma": "Yesterday, ",
    "time.allTime": "All time",

    /* Days of week */
    "days.monday": "Monday",
    "days.tuesday": "Tuesday",
    "days.wednesday": "Wednesday",
    "days.thursday": "Thursday",
    "days.friday": "Friday",
    "days.saturday": "Saturday",
    "days.sunday": "Sunday",

    /* Common */
    "common.add": "Add",
    "common.search": "Search",
    "common.back": "Back",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.close": "Close",
    "common.yes": "Yes",
    "common.no": "No",
    "common.name": "Name",
    "common.view": "View",
    "common.enabled": "Enabled",
    "common.disabled": "Disabled",
    "common.select": "Select",
    "common.selectAll": "Select all",
    "common.clearAll": "Clear all",
    "common.generatePassword": "Generate password",
    "common.send": "Send",

    /* Common swal */
    "swal.deleteConfirm": "Do you really want to delete?",
    "swal.deleteWarning": "Cannot be restored after deletion",
    "swal.deleteButton": "Delete!",
    "swal.cancelButton": "Cancel",
    "swal.noAccess": "No access!",
    "swal.invalidKey": "Invalid key!",
    "swal.generic": "Something went wrong! <br /> Try later.",
    "swal.savedSuccess": "Data saved successfully!",
    "swal.deleteGame": "Delete game?",
    "swal.deleteGameWarning": "Cannot be restored after deletion.",
    "swal.cancelButton2": "Cancel",
    "swal.gameDeleted": "Game deleted!",
    "swal.settingsSaved": "Data saved successfully! <br /> Changes will appear<br /> after page refresh.",

    /* Settings widget */
    "settings.tableName": "Table name",
    "settings.tableKey": "Table key",
    "settings.gameURL": "Game URL",
    "settings.serverURL": "Server URL",
    "settings.type": "Type",
    "settings.image": "Image",
    "settings.currentDealer": "Current Dealer",
    "settings.enterName": "Enter table name",
    "settings.enterKey": "Enter table key",
    "settings.enterGame": "Enter game name",
    "settings.tokenCopied": "Token copied successfully!",
    "settings.save": "Save",
    "settings.mainSection": "General",
    "settings.linksSection": "Links and connection",
    "settings.designSection": "Appearance",
    "settings.tokensSection": "Tokens",
    "settings.infoSection": "Information",
    "settings.dangerSection": "Danger zone",
    "settings.room": "Room",
    "settings.backColor": "Background color",
    "settings.pickColor": "Pick a color",
    "settings.serviceURL": "Studio service URL",
    "settings.studio": "Studio",
    "settings.unknownGame": "This key is not in the games catalogue — the game page will not open",
    "settings.addImage": "Upload image",
    "settings.replaceImage": "Replace image",
    "settings.copy": "Copy",
    "settings.parametersHint": "Visibility, access and working hours are changed on the Parameters tab",
    "settings.gameNotSet": "No game selected",
    "settings.changeGame": "Change",
    "settings.pickGame": "Select game",
    "settings.pickGameHint": "The game key defines the page of the table and the logic of the deal",
    "settings.pickGameEmpty": "No available games of this type",
    "settings.pickGameChoose": "Pick a game from the catalogue",
    "settings.deleteHint": "The table is removed with everything it holds and cannot be restored",

    /* Dashboard */
    "dashboard.filterAll": "All time",
    "dashboard.filterToday": "Today",
    "dashboard.filterYesterday": "Yesterday",
    "dashboard.filterWeek": "This week",
    "dashboard.filterMonth": "This month",
    "dashboard.filterYear": "This year",
    "dashboard.filterPeriod": "Period",
    "dashboard.title": "Dashboard",
    "dashboard.profit": "Profit (GGR)",
    "dashboard.visitors": "Visitors",
    "dashboard.players": "Players",
    "dashboard.rounds": "Rounds",
    "dashboard.games": "Games",
    "dashboard.notes": "Notes",
    "dashboard.activity": "Activity",
    "dashboard.transactions": "Transactions",
    "dashboard.gamesReport": "Games report",
    "dashboard.reportGameName": "Game name",
    "dashboard.reportPlayers": "Number of players",
    "dashboard.reportRounds": "Number of rounds",
    "dashboard.reportDebit": "Bet (DEBIT)",
    "dashboard.reportCredit": "Payout (CREDIT)",
    "dashboard.reportTotal": "Total",
    "dashboard.reportSheet": "Games report",
    "dashboard.playersWord1": "player",
    "dashboard.playersWord24": "players",
    "dashboard.playersWord5": "players",

    /* Dashboard Breakdown — every operator by every studio */
    "dashboard.breakdownTitle": "Operators and studios",
    "dashboard.breakdownNote": "Every operator by every studio, all games of the chosen period",
    "dashboard.breakdownReport": "Operators and studios report (all games)",
    "dashboard.breakdownEmpty": "No operator data for the chosen period",
    "dashboard.breakdownError": "The report failed to load, tap to try again",
    "dashboard.breakdownOperator": "Operator",
    "dashboard.breakdownStudio": "Studio",
    "dashboard.breakdownGame": "Game",
    "dashboard.breakdownGamesCount": "Games",
    "dashboard.breakdownStudiosWord": "studios",
    "dashboard.breakdownGamesWord": "games",
    "dashboard.breakdownShowGames": "Show games",
    "dashboard.breakdownHideGames": "Hide games",
    "dashboard.breakdownOperatorTotal": "Operator total",
    "dashboard.breakdownUnknown": "No name",

    /* Dashboard Filter */
    "dsh.filterTitle": "Dashboard filter",
    "dsh.filterSubtitle": "Period, players, studios and operators",
    "dsh.empty": "No games in the selected period",
    "dsh.searchByStudio": "Search by studio",
    "dsh.studiosEmpty": "No studios available",
    "dsh.filterHint": "An empty choice means every available studio and operator. Only the ones you have access to are shown.",

    /* Game pages */
    "game.title": "Games",
    "game.add": "Add",
    "game.statistics": "Statistics",
    "game.messages": "Messages",
    "game.currencies": "Currencies",
    "game.settings": "Settings",
    "game.parameters": "Parameters",
    "game.writeMessage": "Write message",
    "game.dealers": "Dealers",
    "game.gameNumber": "Game #",
    "game.connectionOk": "Connection established",
    "game.connectionFail": "Connection lost",
    "game.connecting": "Connecting...",
    "game.videoArchive": "Video archive",
    "game.addTitle": "New table",
    "game.tableName": "Table name",
    "game.tableKey": "Table key",
    "game.gameURL": "Game URL",
    "game.serverURL": "Server URL",
    "game.tableStatuses": "Table statuses:",
    "game.tableVisibility": "Table visibility",
    "game.selectGame": "Select game",
    "game.error.emptyName": "Enter table name",
    "game.error.emptyKey": "Enter table key",
    "game.error.invalidKey": "Invalid value",
    "game.error.selectGame": "Select a game",
    "game.addedSuccess": "Game added successfully",
    "game.addSubtitle": "Three steps: the game, the table and the currencies",
    "game.typeSection": "Game type",
    "game.gameSection": "Game",
    "game.tableSection": "Table",
    "game.addType": "New type",
    "game.typeName": "Type name",
    "game.typeKey": "Type key",
    "game.addCatalogGame": "New game",
    "game.gameName": "Game name",
    "game.gameKey": "Game key",
    "game.gamePrefix": "Table prefix",
    "game.catalogHint": "The game key is the segment of the table URL and the value of Tables.game, the prefix starts the names of the game tables",
    "game.emptyType": "This type has no games yet",
    "game.emptyList": "No tables found",
    "game.error.duplicate": "This key is already taken",
    "game.error.emptyTypeName": "Enter the type name",
    "game.error.invalidTypeKey": "Type key: lowercase latin, digits and dashes",
    "game.error.emptyGameName": "Enter the game name",
    "game.error.invalidGameKey": "Game key: lowercase latin, digits and dashes",
    "game.error.selectType": "Select a game type",
    "game.stepGame": "Game",
    "game.stepGameHint": "The type and the game",
    "game.stepTable": "Table",
    "game.stepTableHint": "Name, key, studio",
    "game.stepCurrency": "Currencies",
    "game.stepCurrencyHint": "Limits and chips",
    "game.addressSection": "Addresses and mode",
    "game.selectAllCurrencies": "Select all",
    "game.clearCurrencies": "Clear all",
    "game.currencySection": "Currencies",
    "game.studio": "Studio",
    "game.noStudio": "Not selected",
    "game.studioLive": "A live game is always dealt in a studio",
    "game.studioOptional": "An electronic game does not need a studio",
    "game.keyHint": "Lowercase latin, digits and dashes",
    "game.roomHint": "Stream room, if the table uses one",
    "game.rtpHint": "Return to player of an electronic game",
    "game.visibilityHint": "A disabled table is hidden from the players",
    "game.min": "Minimum bet",
    "game.max": "Maximum bet",
    "game.maxPay": "Maximum payout",
    "game.chips": "Chip nominals",
    "game.chipsHint": "Comma separated, nominal-#color. The values follow the chip rate of the currency",
    "game.emptyCurrency": "Choose the currencies of the table above",
    "game.currencyHint": "Currencies can also be added later, in the table settings",
    "game.catalogTitle": "Catalogue",
    "game.catalogSubtitle": "The game types and the games tables are created from",
    "game.tabTypes": "Types",
    "game.tabGames": "Games",
    "game.allTypes": "All types",
    "game.gamesCount": "games",
    "game.editType": "Edit type",
    "game.editCatalogGame": "Edit game",
    "game.liveType": "Live game",
    "game.liveHint": "Tables of this type are dealt by a dealer in a studio",
    "game.gameColor": "Card color",
    "game.gameVisibility": "Available on creation",
    "game.gameVisibilityHint": "A hidden game is not offered in the selection list",
    "game.keyLocked": "The key cannot be changed — it is used in the routes and in the database",
    "game.gameKeyHint": "The segment of the table route and the value of Tables.game",
    "game.prefixHint": "The beginning of the table names of the game, for example RMP",
    "game.error.selectStudio": "Choose a studio",
    "common.next": "Next",

    /* Electron game widget - games list */
    "widget.searchByNumber": "Search by game number",
    "widget.playerID": "Player ID",
    "widget.to": "to",
    "widget.gameNumber": "Game number",
    "widget.dealer": "Dealer",
    "widget.players": "Players",
    "widget.status": "Status",
    "widget.date": "Date",
    "widget.saved": "Saved",
    "widget.operator": "Operator",
    "widget.winNumber": "Winning number",
    "widget.winner": "Winner",
    "widget.problemHint": "The marked rounds hold transactions that never went through — open a round and check",
    "widget.totalWin": "Win",
    "widget.bets": "Bets",
    "widget.noWin": "No win",
    "widget.paused": "On pause",
    "widget.completed": "Completed",
    "widget.notCompleted": "Not completed",

    /* Game info widget */
    "widget.finishConfirm": "Do you really want to finish the game?",
    "widget.finishWarning": "Cannot be restored after changes",
    "widget.finishButton": "Yes, finish",
    "widget.finishSuccess": "Game finished successfully!",
    "widget.finishDone": "Finished successfully!",
    "widget.alreadyFinished": "Game already finished!",
    "widget.unknownError": "Unknown error! Please try again later.",
    "widget.gamePaused": "Game is on pause!",
    "widget.finishConfirmAlt": "Do you really want to finish the game?",
    "widget.finishWarningAlt": "Cannot be restored after completion",

    /* VipGame game info */
    "widget.game": "Game",
    "widget.gameStatus": "Game status",
    "widget.pauseStatus": "Pause status",
    "widget.changeStatus": "Change status",
    "widget.changed": "Changed",
    "widget.player": "Player",
    "widget.total": "Total",
    "widget.balanceBefore": "Balance before game",
    "widget.balanceAfter": "Balance after game",
    "widget.finishGame": "Finish game",
    "widget.finishAndRefund": "Finish and refund bet",
    "widget.pauseGame": "Pause game",
    "widget.resetCards": "Reset cards",
    "widget.continueWithout": "Continue without changes",
    "widget.pauseConfirm": "Do you really want to pause?",
    "widget.pauseWarning": "Game will be paused",
    "widget.pauseButton": "Yes, pause",
    "widget.alreadyPaused": "Game is already on pause!",
    "widget.gameFinished": "Game finished!",
    "widget.warningStatusDb": "Warning! Status changed only<br /> in database, since<br /> this is not the current game!",
    "widget.finishTxError": "Game is ended! Failed to complete transaction!",

    /* Refund */
    "widget.refundTitle": "Refund bet",
    "widget.payTitle": "Pay amount",
    "widget.totalBet": "Total bet",
    "widget.refunded": "Refunded",
    "widget.paid": "Paid",
    "widget.enterAmount": "Enter amount",
    "widget.pay": "Pay",
    "widget.amountError": "Enter amount",
    "widget.refundSuccess": "Refund completed successfully",
    "widget.paySuccess": "Payment completed successfully",
    "widget.refundTitle2": "Refund: ",
    "widget.payTitle2": "Payment: ",
    "widget.balance": "Balance",
    "widget.playerInfo": "Player information",
    "widget.rouletteNumber": "Number",
    "widget.rouletteBet": "Bet",
    "widget.rouletteWin": "Win",
    "widget.somethingWrong": "Something went wrong! Please try again later!",

    /* Statistics widget */
    "stats.players": "Number of Players",
    "stats.anteBets": "Number of ANTE bets",
    "stats.totalTime": "Total time",
    "stats.profit": "PROFIT:",
    "stats.avgAnte": "Average ANTE bet",
    "stats.combinations": "Combinations",
    "stats.period": "Statistics for period",
    "stats.day": "Day",
    "stats.week": "Week",
    "stats.month": "Month",
    "stats.statsFor": "Statistics for",
    "stats.testerWarning": "Warning! Statistics do not include tester data!",
    "widget.from": "from",

    /* Table Control widget */
    "control.bridgeConnected": "Connected to Bridge",
    "control.bridgeError": "Bridge error",
    "control.noGameConnection": "No connection to game!",
    "control.enterTime": "Enter time",
    "control.tableVisibility": "Table visibility",
    "control.makePublicHidden": "Make the table public or hidden",
    "control.tableFree": "Table is free",
    "control.tableBusy": "Table is busy",
    "control.autoDetect": "Detected automatically",
    "control.tableAccess": "Table access (open/close shift)",
    "control.allowDeny": "Allow or deny entry to table",
    "control.tableClosed": "Table is closed",
    "control.tableOpen": "Table is open",
    "control.allDay": "24/7",
    "control.allDayWork": "Round-the-clock operation",
    "control.workStart": "Work start time",
    "control.workEnd": "Work end time",
    "control.stateSection": "Table state",
    "control.timeSection": "Working hours",

    /* Table panels */
    "panel.controlHint": "Visibility, access and working hours of the table",
    "panel.messageHint": "Messages the players wrote at the table",
    "panel.dealerHint": "Dealers allowed on the table",
    "panel.currencyHint": "Currencies and bet limits",
    "panel.settingsHint": "Parameters and connection of the table",
    "panel.statisticsHint": "Numbers of the game over a period",

    /* Table Refunds widget */
    "refund.transactionNumber": "Transaction number",
    "refund.name": "Name",
    "refund.amount": "Amount",
    "refund.amountUSD": "Amount (USD)",
    "refund.admin": "Admin",
    "refund.dateTime": "Date and time",
    "refund.success": "Success",
    "refund.error": "Error",
    "refund.title": "Refunds",

    /* Round card — the same one in every game */
    "refund.subtitle": "The transactions of the round and who ran the refund",
    "refund.player": "Player",
    "refund.refunded": "Refunds",
    "refund.refundedTotal": "Given back",
    "refund.onlyRefunds": "Refunds only",
    "refund.everything": "Every transaction",
    "refund.byPlayer": "Game",
    "refund.unknownAdmin": "No admin recorded",
    "refund.emptyRefunds": "No refunds were made",
    "refund.emptyRefundsDesc": "No admin gave money back in this round. Open every transaction to see the bets and the payouts.",
    "round.about": "About the round",
    "round.money": "Money of the round",
    "round.actions": "Actions",
    "round.gameActions": "Game actions",
    "round.pauseActions": "Pause",
    "round.paymentActions": "Payments",
    "round.cards": "Cards of the round",
    "round.players": "Players",
    "round.bets": "Bets",
    "round.betsTotal": "Total bets",
    "round.balance": "Balance before and after",
    "round.balanceEmpty": "The operator recorded no balance for this round",
    "round.wallet": "Wallet",
    "round.problem": "Problem",
    "round.noRoundId": "Refunds are out of reach: the round carries no roundId",
    "round.loading": "Loading…",
    "round.playerSubtitle": "The player in this round",
    "round.dealerCards": "Dealer cards",
    "round.playerCards": "Player cards",
    "round.additionalCards": "Additional cards",
    "round.buyCards": "Purchase card",
    "round.bankerCards": "Banker cards",
    "round.positionCard": "Deal start card",
    "round.burnedCards": "Burned cards",
    "round.box": "BOX",
    "round.cardsHidden": "Cards are hidden: the round is neither finished nor paused",

    /* VipGame/MultiGame specific */
    "widget.finishConfirmBtn": "Finish",
    "widget.gamePausedSuccess": "Game paused",
    "widget.gameNotPaused": "Game is not paused!",
    "widget.continueConfirm": "Are you sure you want to continue?",
    "widget.continueText": "Game will continue without changes",
    "widget.gameContinued": "Game continued",
    "widget.resetCardsText": "Cards will be reset",
    "widget.cardsReset": "Cards reset",
    "widget.refundAllConfirm": "Are you sure you want to refund all bets?",
    "widget.refundAllWarning": "This action cannot be undone",
    "widget.refundAllBtn": "Yes, refund all",
    "widget.refundsComplete": "Refunds completed!",
    "widget.searchByPlayerNumber": "Search by player number",
    "widget.gameNumber2": "Game number",
    "widget.roundId": "Round ID",
    "widget.empty": "Empty",
    "widget.playersCount": "Number of players",
    "widget.transactionCount": "Number of transactions",
    "widget.allRefunds": "All refunds",
    "widget.refundAllBets": "Refund all bets",
    "widget.refundAllBetsAndPay": "Refund all bets and payments",
    "widget.continueGame": "Continue game",
    "widget.refundAndPayAllConfirm": "Are you sure you want to refund bets and payments for everyone?",
    "widget.allRefundsComplete": "All refunds completed!",
    "widget.operationConfirm": "Are you sure you want to perform this operation?",

    /* Studio Room */
    "studio.participantsTitle": "Participants",
    "studio.nameLabel2": "Name",
    "studio.disconnectStream": "Disconnect stream",

    /* Bonus Jackpot Connect/Update */
    "bonus.selectOperator": "Select operator",
    "bonus.cashLabel": "Cash, $",
    "bonus.visibility": "Visibility",
    "bonus.connect2": "Connect",
    "bonus.connectJackpotTitle": "Connect JACKPOT",
    "bonus.send": "Send",

    /* Player widget */
    "player.information": "General\u0020information",
    "player.sessions": "Sessions",
    "player.filter": "Filter",
    "player.operators": "Operators",
    "player.selectOperator": "Select at least 1 operator",
    "player.selectDates": "Select dates",
    "player.last3h": "Last 3 hours",
    "player.last6h": "Last 6 hours",
    "player.last12h": "Last 12 hours",
    "player.today": "Today",
    "player.yesterday": "Yesterday",
    "player.last7days": "Last 7 days",
    "player.last14days": "Last 14 days",
    "player.last30days": "Last 30 days",
    "player.thisMonth": "This month",
    "player.prevMonth": "Previous month",
    "player.allTime": "All time",
    "player.tester": "Tester",
    "player.player": "Player",
    "player.operator": "Operator",
    "player.rounds": "Number of rounds",
    "player.avgBet": "Average bet",
    "player.totalTime": "Total time",
    "player.selectPeriod": "Select period",
    "player.statsAll": "All\u00A0time",
    "player.statsDay": "Day",
    "player.statsWeek": "Week",
    "player.statsMonth": "Month",
    "player.statsPeriod": "Period",
    "player.roundCount": "Number of rounds",
    "player.report": "Players report",
    "player.reportName": "Player name",
    "player.reportCode": "Player code",
    "player.reportLastGame": "Last game",
    "player.reportOperator": "Operator",
    "player.reportCurrency": "Currency",
    "player.reportLastSession": "Last session",
    "player.reportTester": "Tester",
    "player.reportVip": "VIP",
    "player.reportTesterYes": "Yes",
    "player.reportTesterNo": "No",
    "player.reportSheet": "Players report",
    "player.title": "Players",
    "player.lastGame": "Last game",
    "player.currency": "Currency",
    "player.balance": "Balance",
    "player.dateTime": "Date and time",
    "player.statsTitle": "Player statistics",
    "player.isTester": "Tester",
    "player.isVip": "VIP",
    "player.viewStats": "View statistics",
    "player.setTester": "Mark as tester",
    "player.removeTester": "Remove tester status",
    "player.setVip": "Enable VIP status",
    "player.removeVip": "Disable VIP status",
    "player.setBlocked": "Block",
    "player.removeBlocked": "Unblock",
    "player.blocked": "Blocked",
    "player.search": "Search by name and code",
    "player.hideTesters": "Hide testers",
    "player.filterPeriod": "Period",
    "player.changeConfirm": "Do you really want to change?",
    "player.changeWarning": "This affects statistics",
    "player.changeVipWarning": "This affects the player's VIP status",
    "player.changeBlockWarning": "A blocked player will not be able to enter any game",
    "player.changeUnblockWarning": "The player will be able to enter games again",
    "player.statusChanged": "Status changed successfully",
    "player.sessionSid": "Session SID",
    "player.sessionLastGame": "Last game",
    "player.sessionGames": "Games",
    "player.sessionRounds": "Rounds",
    "player.sessionTransactions": "Transactions",
    "player.sessionEntered": "Entered",
    "player.sessionLastTx": "Last transaction",
    "player.sessionsEmpty": "No sessions found",
    "player.roundsTab": "Rounds",
    "player.roundsTotal": "Total rounds",
    "player.roundTxs": "Transactions",
    "player.roundsEmpty": "No rounds found",

    /* Players section */
    "plr.empty": "No players found",
    "plr.noGame": "Game removed",
    "plr.activity": "Activity",
    "plr.more": "More",
    "plr.playersCount": "Players",
    "plr.testersCount": "Testers",
    "plr.sessionsCount": "Sessions",
    "plr.roundsCount": "Rounds",
    "plr.debitNote": "Player bets",
    "plr.creditNote": "Player payouts",
    "plr.copyCode": "Copy player code",
    "plr.codeCopied": "Player code copied",
    "plr.filterTitle": "Players filter",
    "plr.filterSubtitle": "Period, order, operators and games",
    "plr.filterHint": "An empty selection means every game of your access",
    "plr.searchByOperator": "Search by operator",
    "plr.sort": "Order",
    "plr.sortDate": "By last activity",
    "plr.sortGgr": "GGR descending",
    "plr.sortGgrAsc": "GGR ascending",
    "plr.sortDebit": "By bets",
    "plr.sortRounds": "By rounds",
    "plr.sortName": "By name",
    "plr.totalTitle": "Total",
    "plr.watchButton": "Entry watch",
    "plr.watchTitle": "Player entry watch",
    "plr.watchSubtitle": "A telegram message is sent whenever a watched player opens any game",
    "plr.watchPlayer": "Player ID",
    "plr.watchOperator": "Operator",
    "plr.watchAdd": "Add",
    "plr.watchEmpty": "The list is empty — add a player to be notified about the entry",
    "plr.watchEnterPlayer": "Enter the player ID",
    "plr.watchSelectOperator": "Select an operator",
    "plr.watchExists": "This player is already on the list",
    "plr.watchAdded": "Player added to the entry watch",
    "plr.watchRemoved": "Player removed from the entry watch",
    "plr.watchLastLogin": "last entry",
    "plr.watchNeverEntered": "never entered",
    "plr.notifyOff": "Notify on entry",
    "plr.notifyOn": "Notifications on",
    "plr.notifyEnabled": "Entry notifications enabled",
    "plr.notifyDisabled": "Entry notifications disabled",
    "plr.roundsShort": "Rounds",
    "plr.betShort": "Avg bet",
    "plr.timeShort": "Time played",
    "plr.periodStats": "Statistics by period",
    "plr.gamesNote": "all time",
    "plr.games": "Games",
    "plr.gamesShort": "games",
    "plr.gamesEmpty": "The player has no games yet",
    "plr.pickerSubtitle": "Select the start and the end of the period",
    "plr.sessionsHint": "Click a session to open its rounds",
    "plr.sidCopied": "Session code copied",
    "plr.copySid": "Copy session code",
    "plr.openRounds": "Open the rounds of the session",
    "plr.clearSession": "Show every round",
    "plr.clearGame": "Remove the game filter",
    "plr.openGameRounds": "Open the rounds of the game",
    "plr.gamesHint": "Click a game to open its rounds",
    "plr.copyRound": "Copy round number",
    "plr.roundCopied": "Round number copied",
    "plr.txEmpty": "No transactions found in the round",

    /* Manager pages */
    "manager.title": "Managers",
    "manager.createTitle": "Create administrator",
    "manager.createSubtitle": "Pick a role and assign the access",
    "manager.editTitle": "Edit administrator",
    "manager.editSubtitle": "The role and the access can be changed at any time",
    "manager.historyTitle": "Login history",
    "manager.activityTitle": "Activity",
    "manager.name": "Name",
    "manager.role": "Role",
    "manager.scope": "Access",
    "manager.scopeGlobal": "All studios and operators",
    "manager.scopeGlobalHint": "A manager sees every studio and every operator",
    "manager.scopeEmpty": "No access assigned",
    "manager.studios": "Studios",
    "manager.operators": "Operators",
    "manager.selectRole": "Select role",
    "manager.selectStudio": "Select studio",
    "manager.activity": "Activity",
    "manager.history": "Login history",
    "manager.edit": "Edit",
    "manager.changePassword": "Change password",
    "manager.delete": "Delete",
    "manager.newPassword": "New password",
    "manager.repeatNewPassword": "Repeat new password",
    "manager.addedSuccess": "Administrator added successfully",
    "manager.savedSuccess": "Administrator saved successfully",
    "manager.deletedSuccess": "Administrator deleted successfully",
    "manager.passwordSaved": "Password saved successfully",
    "manager.device": "Device",
    "manager.browser": "Browser",
    "manager.ip": "IP address",
    "manager.country": "Country, City",
    "manager.lastActivity": "Last activity",
    "manager.game": "Game",
    "manager.action": "Action",
    "manager.dateTime": "Date and time",
    "manager.general": "General",
    "manager.roleText.manager": "Every studio and operator except superadmin settings",
    "manager.roleText.pitboss": "Runs a single studio of their own",
    "manager.roleText.viewer": "Read-only access to the selected operators",
    "manager.selectRoleHint": "Pick a role first — it defines which access has to be assigned",
    "manager.pitbossHint": "A pitboss manages the tables and dealers of their own studio only",
    "manager.viewerHint": "A viewer sees the tables of the selected operators inside the selected studios — without the right to change anything",
    "manager.nothingAvailable": "Nothing available",
    "manager.passwordHint": "After the password is changed the administrator has to sign in again",
    "manager.superadminLocked": "Editing unavailable",
    "manager.you": "You",
    "manager.empty": "No administrators yet",
    "manager.noHistory": "No sign-ins yet",
    "manager.noActivity": "No activity yet",
    "manager.error.emptyName": "Enter a name",
    "manager.error.emptyEmail": "Enter Email",
    "manager.error.invalidEmail": "Invalid Email format",
    "manager.error.emptyPassword": "Enter password",
    "manager.error.shortPassword": "Password must be at least 8 characters",
    "manager.error.selectRole": "Select a role",
    "manager.error.oneStudio": "A pitboss must be assigned exactly one studio",
    "manager.error.emptyStudios": "Select at least one studio",
    "manager.error.emptyOperators": "Select at least one operator",

    /* Profile panels */
    "profile.title": "Profile",
    "profile.subtitle": "Account data and permissions",
    "profile.data": "Data",
    "profile.access": "Access",
    "profile.currentSession": "Current session",
    "profile.uploadImage": "Upload image",
    "profile.removeImage": "Remove image",
    "profile.removeImageTitle": "Remove the image?",
    "profile.removeImageText": "The first letters of the name will be shown instead",
    "profile.stats.games": "Games",
    "profile.stats.studios": "Studios",
    "profile.stats.operators": "Operators",
    "profile.stats.sessions": "Logins",
    "profile.stats.created": "Member since",
    "profile.scope.global": "Full access to every studio, game and operator",
    "profile.scope.empty": "No permissions granted yet — ask an administrator",
    "profile.changePasswordSubtitle": "A new password of 8 characters or more",
    "profile.rule.length": "At least 8 characters",
    "profile.rule.letter": "Contains a letter",
    "profile.rule.digit": "Contains a digit",
    "profile.rule.different": "Differs from the current one",
    "profile.strength.weak": "Weak",
    "profile.strength.medium": "Medium",
    "profile.strength.good": "Good",
    "profile.strength.strong": "Strong",
    "profile.historySubtitle": "Devices and logins of the panel",
    "profile.noHistory": "The login history is still empty",
    "profile.records": "records",
    "profile.thisDevice": "This device",
    "profile.wrongPassword": "Wrong password",
    "profile.failed": "Login failed",
    "profile.error.image": "Up to 5 MB: PNG, JPG or WEBP",
    "profile.error.samePassword": "The new password matches the current one",
    "profile.image": "Image",
    "profile.name": "Name",
    "profile.save": "Save",
    "profile.savedSuccess": "Data saved successfully",
    "profile.imageSaved": "Image saved successfully",
    "profile.imageDeleted": "Image deleted successfully",
    "profile.error.emptyName": "Enter name",
    "profile.changePassword": "Change password",
    "profile.currentPassword": "Current password",
    "profile.newPassword": "New password",
    "profile.repeatPassword": "Repeat password",
    "profile.error.emptyCurrentPwd": "Enter current password",
    "profile.error.shortCurrentPwd": "Password must be at least 8 characters",
    "profile.error.emptyNewPwd": "Enter new password",
    "profile.error.shortNewPwd": "Password must be at least 8 characters",
    "profile.error.mismatch": "Passwords do not match",
    "profile.passwordChanged": "Password changed successfully!",
    "profile.error.wrongPassword": "Wrong password!",
    "profile.error.authError": "Authorization error!",
    "profile.historyTitle": "Login history",
    "profile.device": "Device",
    "profile.browser": "Browser",
    "profile.ipAddress": "IP address",
    "profile.countryCity": "Country, City",
    "profile.lastActivity": "Last activity",

    /* Page 404 */
    "page404.text": "The page you requested does not exist.",

    /* Dealer pages */
    "dealer.title": "Dealers",
    "dealer.add": "Add",
    "dealer.name": "Name",
    "dealer.gamesCount": "Number of games",
    "dealer.qrCode": "QR code",
    "dealer.downloadPng": "Download .PNG",
    "dealer.edit": "Edit",
    "dealer.delete": "Delete",
    "dealer.addTitle": "Add dealer",
    "dealer.editTitle": "Edit dealer",
    "dealer.createSubtitle": "Pick a studio and assign the table access",
    "dealer.editSubtitle": "The studio and the table access can be changed at any time",
    "dealer.dealerName": "Dealer name",
    "dealer.studio": "Studio",
    "dealer.tables": "Tables",
    "dealer.tableAccess": "Table access",
    "dealer.tableAccessHint": "The dealer only works at the selected tables of their studio",
    "dealer.selectStudioHint": "Pick a studio first — the list of available tables depends on it",
    "dealer.noStudio": "No studio assigned",
    "dealer.noStudios": "No studios available",
    "dealer.studioLocked": "The studio of a dealer can not be changed",
    "dealer.noTables": "This studio has no tables yet",
    "dealer.generatePin": "Generate PIN",
    "dealer.searchByName": "Search by dealer name",
    "dealer.nothingFound": "No dealers found",
    "dealer.empty": "No dealers yet",
    "dealer.viewOnly": "View only",
    "dealer.error.emptyName": "Enter dealer name",
    "dealer.error.emptyPin": "Enter PIN/Barcode",
    "dealer.error.pinLength": "PIN/barcode length must be 6 characters",
    "dealer.error.selectStudio": "Select a studio",
    "dealer.addedSuccess": "Dealer added successfully",
    "dealer.savedSuccess": "Dealer saved successfully",
    "dealer.deletedSuccess": "Dealer deleted successfully",
    "dealer.added": "Dealer added",
    "dealer.removed": "Dealer removed",

    /* Currency pages */
    "currency.title": "Currencies",
    "currency.name": "Name",
    "currency.code": "Code",
    "currency.symbol": "Symbol",
    "currency.add": "Add",
    "currency.edit": "Edit",
    "currency.delete": "Delete",
    "currency.addTitle": "Add currency",
    "currency.editTitle": "Edit currency",
    "currency.createSubtitle": "Code, symbol and chip coefficient of the currency",
    "currency.editSubtitle": "Changes apply instantly on every table",
    "currency.symbolBefore": "Place symbol after number",
    "currency.chipRate": "Chip coefficient",
    "currency.chipRateShort": "Chip coef.",
    "currency.chipRateHint": "The nominal of a chip in this currency is multiplied by this number",
    "currency.usedOn": "Tables",
    "currency.searchByName": "Search by name or code",
    "currency.nothingFound": "No currencies found",
    "currency.empty": "No currencies yet",
    "currency.superadminOnly": "Superadmin only",
    "currency.error.emptyName": "Enter currency name",
    "currency.error.emptyCode": "Enter currency code",
    "currency.error.codeLength": "Code length must be 3 characters",
    "currency.error.emptySymbol": "Enter currency symbol",
    "currency.error.chipRate": "Enter a valid chip coefficient",
    "currency.addedSuccess": "Currency added successfully",
    "currency.savedSuccess": "Currency saved successfully",
    "currency.deletedSuccess": "Currency deleted successfully",
    "currency.alreadyAdded": "Currency already added",
    "currency.selectCurrency": "Select currency",
    "currency.maxBet": "Maximum bet",
    "currency.minBonusBet": "Minimum bonus bet",
    "currency.maxBonusBet": "Maximum bonus bet",
    "currency.minBet": "Minimum bet",
    "currency.maxPay": "Maximum payout",
    "currency.chips": "Chips (comma separated)",
    "currency.maxPP": "Maximum PERFECT PAIR",
    "currency.max21": "Maximum 21+3",
    "currency.maxBust": "Maximum BUST",
    "currency.maxCS": "Maximum CRAZY SEVEN",
    "currency.maxBetShort": "Max. bet",
    "currency.minBetShort": "Min. bet",
    "currency.maxPayShort": "Max. payout",
    "currency.chipsLabel": "Chips",
    "currency.create": "Create",
    "currency.enterCurrency": "Select currency",
    "currency.enterMaxBet": "Enter maximum bet",
    "currency.enterMaxPP": "Enter maximum PERFECT PAIR",
    "currency.enterMax21": "Enter maximum 21+3",
    "currency.enterMaxBust": "Enter maximum BUST",
    "currency.enterMaxCS": "Enter maximum CRAZY SEVEN",
    "currency.enterMinBet": "Enter minimum bet",
    "currency.enterMaxPay": "Enter maximum payout",
    "currency.enterChips": "Enter chips list",
    "currency.maxBonusShort": "Max. bonus",
    "currency.emptyOnTable": "No currencies on this table yet",
    "currency.allAdded": "Every currency is already added",
    "currency.limits": "Bet limits",
    "currency.limitsSubtitle": "The limits apply to this table only",
    "currency.sideBets": "Side bets",
    "currency.applyToAll": "Apply to every currency of the game",
    "currency.applyToAllHint": "Every currency of the table becomes a copy of the dollar: limits and chip values are multiplied by the currency rate, while the chip count and colors are taken from the dollar.",
    "currency.chipsHint": "Chip nominals separated by a comma, for example 1,5,25,100",

    /* Card pages */
    "card.title": "Cards",
    "card.value": "Value",
    "card.barcode": "Barcode",
    "card.card": "Card",
    "card.changed": "Changed",

    /* Card list */
    "card.total": "Cards total",
    "card.suits": "Suits",
    "card.filled": "With barcode",
    "card.doubles": "Duplicates",
    "card.duplicate": "Duplicate",
    "card.noBarcode": "No barcode",
    "card.empty": "The deck is empty",

    /* Card suits */
    "card.suit.heart": "Hearts",
    "card.suit.diamond": "Diamonds",
    "card.suit.club": "Clubs",
    "card.suit.spade": "Spades",
    "card.suit.other": "Other",

    /* Card modal */
    "card.editTitle": "Change Barcode",
    "card.barcodeHint": "Barcode is the scanner code of a card. Latin letters, numbers, a dot, a dash and an underscore, up to 32 characters.",
    "card.busyHint": "This barcode already belongs to the card",
    "card.savedSuccess": "Barcode saved successfully",
    "card.error.emptyBarcode": "Enter Barcode",
    "card.error.formatBarcode": "Only latin letters, numbers, a dot, a dash and an underscore",
    "card.error.busyBarcode": "This barcode already belongs to another card",

    /* Operator page */
    "operator.title": "Operators",
    "operator.name": "Name",
    "operator.edit": "Edit",
    "operator.delete": "Delete",
    "operator.addTitle": "Add operator",
    "operator.editTitle": "Edit operator",
    "operator.createSubtitle": "Integration details and table access",
    "operator.editSubtitle": "Changes apply to every game of the operator right away",
    "operator.mainSection": "Main",
    "operator.integrationSection": "Integration",
    "operator.tables": "Tables",
    "operator.managers": "Managers",
    "operator.tableAccess": "Table access",
    "operator.tableAccessHint": "The operator can open only the selected tables",
    "operator.pathHint": "Startpoint is the address of the operator, the other fields are paths on it (for example /api/balance)",
    "operator.licenseNumber": "License number",
    "operator.noStartpoint": "No startpoint",
    "operator.noTables": "No tables yet",
    "operator.withoutStudio": "Without studio",
    "operator.searchByName": "Search by name or Slug",
    "operator.nothingFound": "No operators found",
    "operator.empty": "No operators yet",
    "operator.superadminOnly": "Superadmin only",
    "operator.token": "Token",
    "operator.tokenTitle": "Operator token",
    "operator.tokenEmpty": "No token created",
    "operator.tokenHint": "The operator needs this token for API requests. The old token stops working right after the update",
    "operator.tokenButton": "Update token",
    "operator.tokenConfirm": "Update the token of the operator?",
    "operator.tokenSuccess": "Token updated successfully",
    "operator.tokenCopied": "Token copied",
    "operator.copyToken": "Copy token",
    "operator.copyFailed": "Token was not copied",
    "operator.error.emptyName": "Enter the name of the operator",
    "operator.error.emptySlug": "Enter the Slug of the operator",
    "operator.error.slugFormat": "Slug accepts only latin letters, numbers, a dash and an underscore",
    "operator.error.emptyStartpoint": "Enter Startpoint",
    "operator.error.startpointFormat": "Startpoint has to start with http:// or https://",
    "operator.error.emptyBalance": "Enter Balance URL",
    "operator.error.emptyDebit": "Enter Debit URL",
    "operator.error.emptyCredit": "Enter Credit URL",
    "operator.error.pathFormat": "A path has to start with /",
    "operator.addedSuccess": "Operator added successfully",
    "operator.savedSuccess": "Operator saved successfully",
    "operator.deletedSuccess": "Operator deleted successfully",

    /* Bonus page */
    "bonus.notFound": "Nothing found for your request",
    "bonus.operator": "Operator",
    "bonus.game": "Game",
    "bonus.player": "Player",
    "bonus.bet": "Bet",
    "bonus.win": "Win",
    "bonus.date": "Date",
    "bonus.info": "Information",
    "bonus.number": "Number",
    "bonus.gameNumber": "Game number #",
    "bonus.exchangeRate": "Exchange rate (to USD)",
    "bonus.combination": "Combination",
    "bonus.multiplier": "Multiplier",
    "bonus.cash": "Cash",
    "bonus.filter": "Filter",
    "bonus.operators": "Operators",
    "bonus.search": "Search by game number or player code",
    "bonus.title": "Bonus",
    "bonus.settings": "Settings",
    "bonus.games": "Games",
    "bonus.reset": "Reset",
    "bonus.jackpotNotConnected": "not connected",
    "bonus.connectJackpot": "Connect JACKPOT to operator",
    "bonus.connect": "Connect",
    "bonus.cashRegister": "CASH",
    "bonus.active": "Active",
    "bonus.disabled": "Disabled",
    "bonus.jackpotSettings": "JACKPOT Settings",

    /* Studio pages */
    "studio.title": "Studios",
    "studio.name": "Name",
    "studio.code": "Code",
    "studio.token": "Token",
    "studio.edit": "Edit",
    "studio.delete": "Delete",
    "studio.add": "Add",
    "studio.deleteConfirm": "Do you really want to delete the studio?",
    "studio.deleteWarning": "Cannot be restored after changes",
    "studio.deleteButton": "Yes, delete",
    "studio.deletedSuccess": "Studio deleted successfully!",
    "studio.createdTitle": "Create studio",
    "studio.editTitle": "Edit",
    "studio.savedSuccess": "Data saved successfully!",
    "studio.nameLabel": "Name",
    "studio.codeLabel": "Code",
    "studio.error.emptyName": "Enter name",
    "studio.error.emptyCode": "Enter code",
    "studio.error.emptyServiceURL": "Enter Service URL",
    "studio.error.emptySocketURL": "Enter Socket URL",
    "studio.createdSuccess": "Studio created successfully!",
    "studio.addresses": "Addresses",
    "studio.content": "Content",
    "studio.tables": "Tables",
    "studio.dealers": "Dealers",
    "studio.admins": "Admins with access",
    "studio.empty": "No studios found",
    "studio.viewOnly": "View only",
    "studio.tokenCopied": "Token copied!",
    "studio.createSubtitle": "A new studio and the addresses of its server",
    "studio.editSubtitle": "Studio data and the addresses of its server",
    "studio.mainSection": "Main",
    "studio.addressSection": "Server addresses",
    "studio.addressHint": "Service URL — stream control, Socket URL — stream connection, Record URL — the archive of records. The address is stored without a trailing slash.",

    /* Studio stream */
    "studio.streams": "Streams",
    "studio.participants": "Participants",
    "studio.video": "Video",
    "studio.audio": "Audio",
    "studio.allTime": "All time",
    "studio.load": "Load",
    "studio.yes": "Yes",
    "studio.no": "No",
    "studio.streamTitle": "Studio broadcasts",
    "studio.streamSubtitle": "The state of the streaming server",
    "studio.refresh": "Refresh",
    "studio.archive": "Archive",
    "studio.openLink": "Open link",
    "studio.liveStreams": "Live broadcasts",
    "studio.noStreams": "There are no live broadcasts",

    /* Studio room (stream control) */
    "studio.disableStreamTitle": "Disable stream?",
    "studio.disableStreamText": "Do you really want to disable the stream?",
    "studio.disableStreamButton": "Disable",
    "studio.disabledSuccess": "Successfully disabled!",
    "studio.participantsSubtitle": "Participants of the broadcast",
    "studio.noParticipants": "There is nobody in the broadcast",
    "studio.publisher": "Publishing",
    "studio.viewer": "Watching",
    "studio.publisherLocked": "The source of the broadcast cannot be disabled",

    /* Message page */
    "message.title": "Message",
    "message.player": "Player",
    "message.game": "Game",
    "message.text": "Message",
    "message.dateTime": "Date and time",
    "message.tables": "Tables",
    "message.selectTable": "Select tables to filter",
    "message.empty": "No messages yet",
    "message.loadMore": "Load more",
    "message.loading": "Loading ...",

    /* Messages section */
    "msg.title": "Messages",
    "msg.search": "Player, text, game number or dealer",
    "msg.filter": "Filter",
    "msg.player": "Player",
    "msg.game": "Game",
    "msg.operator": "Operator",
    "msg.tester": "Tester",
    "msg.text": "Message",
    "msg.dealer": "Dealer",
    "msg.date": "Date",
    "msg.noGame": "Game deleted",
    "msg.empty": "No messages yet",
    "msg.nothingFound": "Nothing found",
    "msg.openPlayer": "Open the player",
    "msg.copyText": "Copy the message",
    "msg.copied": "Copied!",
    "msg.copyFailed": "Failed to copy",

    /* Messages numbers */
    "msg.total": "Messages",
    "msg.playersCount": "Players",
    "msg.gamesCount": "Games",
    "msg.dealersCount": "Dealers",
    "msg.lastMessage": "Last one",

    /* Messages filter */
    "msg.filterTitle": "Messages filter",
    "msg.filterSubtitle": "Period, operators and games of your access",
    "msg.period": "Period",
    "msg.dateFrom": "Date from",
    "msg.dateTo": "Date to",
    "msg.players": "Players",
    "msg.includeTesters": "Show test accounts",
    "msg.operators": "Operators",
    "msg.games": "Games",
    "msg.searchByGame": "Search by game or studio",
    "msg.gamesEmpty": "No games available",
    "msg.filterHint": "An empty selection means every game of your access. Pick the ones you need to narrow the list.",
    "msg.reset": "Reset",

    /* Messages tabs and censor mark */
    "msg.tab.all": "All messages",
    "msg.tab.censored": "Bad language",
    "msg.censored": "Censored",
    "msg.censoredCount": "Censored",
    "msg.censoredHint": "The players at the table read *** instead of the forbidden word, here the text is shown as it was typed",
    "msg.emptyCensored": "No bad language in this period",

    /* Censor dictionary */
    "censor.tab": "Dictionary",
    "censor.search": "Word or note",
    "censor.word": "Word",
    "censor.wordLabel": "Word or root",
    "censor.wordHint": "The case, latin letters instead of cyrillic ones, digits instead of letters, spaces and dots inside a word change nothing: \"f u c k\", \"F.U.C.K\" and \"fuuuck\" are one and the same word.",
    "censor.type": "Type",
    "censor.type.root": "Root",
    "censor.type.exact": "Exact word",
    "censor.type.exactHint": "An exact word matches a whole word only — \"ass\" never touches \"class\".",
    "censor.type.rootHint": "A root matches anywhere inside a word and covers every form of it at once. Never take a root that lives inside ordinary words.",
    "censor.comment": "Note",
    "censor.status": "Status",
    "censor.author": "Author",
    "censor.on": "On",
    "censor.off": "Off",
    "censor.total": "Words",
    "censor.active": "On",
    "censor.inactive": "Off",
    "censor.empty": "The dictionary is empty",
    "censor.note": "The dictionary is one for every game. The game servers keep it in memory and read it anew right after a change — no restart is needed. The chat shows *** instead of the whole word, the database keeps the message as it was typed.",
    "censor.add": "Add a word",
    "censor.save": "Save",
    "censor.edit": "Change the word",
    "censor.delete": "Delete the word",
    "censor.switchOn": "Switch on",
    "censor.switchOff": "Switch off",
    "censor.createTitle": "New word",
    "censor.editTitle": "Change the word",
    "censor.formSubtitle": "A forbidden word for the chats of every game",
    "censor.created": "The word is added",
    "censor.updated": "The word is changed",
    "censor.deleted": "The word is deleted",
    "censor.switchedOn": "The word is switched on",
    "censor.switchedOff": "The word is switched off",
    "censor.deleteConfirm": "Delete the word from the dictionary?",
    "censor.deleteButton": "Delete",
    "censor.error.empty": "Enter a word",
    "censor.error.long": "The word is too long",

    /* Notification panels */
    "notification.title": "Notifications",
    "notification.subtitle": "Events of your tables",
    "notification.records": "records",
    "notification.unread": "new",
    "notification.readAll": "Read all",
    "notification.empty": "There are no notifications yet",
    "notification.new": "New",
    "notification.go": "Go",
    "notification.goTable": "Open the table",
    "notification.pauseTitle": "The game is paused",
    "notification.pauseText": "The table has stopped the game and waits for a decision",
    "notification.alsoPaused": "Also paused",

    /* Support chat */
    "support.title": "Support",
    "support.inputPlaceholder": "Enter message...",
    "support.searchPlaceholder": "Search by player or game",
    "support.notFound": "Nothing found",
    "support.you": "You",
    "support.today": "Today",
    "support.yesterday": "Yesterday",
    "support.playerType": "Player",
    "support.adminType": "Admin",
    "support.noMessages": "No messages yet",
    "support.noMessagesDesc": "Support has not been contacted yet",
    "support.messageSent": "Message sent successfully",
    "support.messagePlaceholder": "Message",
    "support.emptyMessage": "Enter message",

    /* Table / Control widget */
    "table.bridgeConnected": "Connected to Bridge",
    "table.bridgeError": "Bridge error",
    "table.noGameConnection": "No connection to the game!",
    "table.save": "Save",
    "table.visibility": "Table visibility",
    "table.visibilityDesc": "Make the table public or hidden",
    "table.free": "Table is free",
    "table.busy": "Table is busy",
    "table.autoDetected": "Detected automatically",
    "table.access": "Table access (open/close shift)",
    "table.accessDesc": "Allow or deny entry to the table",
    "table.closed": "Table closed",
    "table.working": "Table is working",
    "table.allDay": "24/7",
    "table.allDayDesc": "Round-the-clock operation",
    "table.startTime": "Work start time",
    "table.endTime": "Work end time",
    "table.error.emptyStart": "Enter time",
    "table.error.emptyEnd": "Enter time",
    "table.deleteConfirm": "Delete game?",
    "table.deleteWarning": "Cannot be restored after deletion.",
    "table.deleteCancel": "Cancel",
    "table.deleteButton": "Delete",
    "table.deletedSuccess": "Game deleted!",

    /* Table / Dealer widget */
    "table.dealerAdded": "Dealer added",
    "table.dealerRemoved": "Dealer removed",

    /* Table / Refunds */
    "table.refundTxNumber": "Transaction number",
    "table.refundName": "Name",
    "table.refundAmount": "Amount",
    "table.refundAmountUSD": "Amount (USD)",
    "table.refundStatus": "Status",
    "table.refundAdmin": "Admin",
    "table.refundDateTime": "Date and time",
    "table.refundSuccess": "Success",

    /* Bonus widgets */
    "jackpot.notConnected": "JACKPOT not connected",
    "jackpot.connectDesc": "Connect JACKPOT to operator",
    "jackpot.connect": "Connect",
    "jackpot.cash": "CASH",
    "jackpot.active": "Active",
    "jackpot.disabled": "Disabled",
    "jackpot.settings": "JACKPOT settings",
    "jackpot.selectOperator": "Select operator",
    "jackpot.cashLabel": "Cash, $",
    "jackpot.visibility": "Visibility",
    "jackpot.connectButton": "Connect",

    /* Timezone */
    "timezone.title": "Select timezone",
    "timezone.confirmTitle": "Your timezone",
    "timezone.confirmText": "Detected from your device. Is it correct?",
    "timezone.yes": "Yes, correct",
    "timezone.change": "Change",

    /* RSG Reports */
    "rsg.title": "RSG Reports",
    "rsg.gamesTitle": "RSG games",
    "rsg.tabReports": "Reports",
    "rsg.tabGames": "Games",

    /* RSG Reports — list */
    "rsg.fileName": "File",
    "rsg.reportDate": "Report period",
    "rsg.sentAt": "Sent at",
    "rsg.status": "Status",
    "rsg.ggr": "GGR",
    "rsg.games": "Games",
    "rsg.uploaded": "Uploaded",
    "rsg.notUploaded": "Not uploaded",
    "rsg.allTypes": "All types",
    "rsg.searchByFile": "File or hash",
    "rsg.reportsEmpty": "No reports found",
    "rsg.nothingFound": "Nothing found",

    /* RSG Reports — detail modal */
    "rsg.detailTitle": "Report details",
    "rsg.detailSubtitle": "Everything the regulator received",
    "rsg.totals": "Totals",
    "rsg.information": "About the report",
    "rsg.amountIn": "In",
    "rsg.amountOut": "Out",
    "rsg.noHash": "No hash",
    "rsg.copyHash": "Copy hash",
    "rsg.hashCopied": "Hash copied",
    "rsg.copyFailed": "Copying failed",
    "rsg.fileDownload": "Download XML",
    "rsg.fileMissing": "File is not available on the server",
    "rsg.fileMissingHint": "The XML file is not on the disk, so it cannot be downloaded. The report has already been sent to the regulator, only its data is left here.",
    "rsg.fileRegenerated": "regenerated",
    "rsg.fileRegeneratedHint": "The report was regenerated after it had been sent — the download gives a version newer than the sent one:",
    "rsg.searchByGame": "Table or game ID",
    "rsg.empty": "No games in this report",

    /* RSG Games — list */
    "rsg.tableName": "Table",
    "rsg.studio": "Studio",
    "rsg.gameID": "RSG game ID",
    "rsg.gameIDPlaceholder": "Not set",
    "rsg.allTables": "All tables",
    "rsg.searchByTable": "Table, studio or game ID",
    "rsg.gamesEmpty": "No tables found",
    "rsg.inReport": "In report",
    "rsg.notInReport": "Disabled",
    "rsg.noGameID": "No game ID",
    "rsg.state.active": "In report",
    "rsg.state.off": "Disabled",
    "rsg.state.empty": "Without game ID",
    "rsg.superadminOnly": "Superadmin only",

    /* RSG Games — form modal */
    "rsg.gameTitle": "RSG game ID",
    "rsg.gameIDHint": "The identifier is issued by the regulator. An empty value removes the table from the reports.",
    "rsg.reportState": "Inclusion in reports",
    "rsg.inReportNote": "The table data goes into the next report",
    "rsg.notInReportNote": "The table stays out of the reports",
    "rsg.gameIDSaved": "Game ID saved",
    "rsg.gameIDRemoved": "Game ID removed",
    "rsg.error.gameIDFormat": "The ID may contain latin letters, numbers, a dot, a dash and an underscore only",

    /* GAME TRANSACTIONS */
    "gtx.title": "Transactions",
    "gtx.search": "Player, ID, transaction number, round number",
    "gtx.operator": "Operator",
    "gtx.game": "Game",
    "gtx.games": "Games",
    "gtx.selectGame": "Select games to filter",
    "gtx.player": "Player",
    "gtx.playerName": "Player name",
    "gtx.playerID": "Player ID",
    "gtx.reason": "Reason",
    "gtx.status": "Status",
    "gtx.type": "Type",
    "gtx.amount": "Amount",
    "gtx.amountUSD": "Amount in USD",
    "gtx.balance": "Balance",
    "gtx.balanceBefore": "Balance before",
    "gtx.balanceAfter": "Balance after",
    "gtx.refund": "Refund",
    "gtx.date": "Date",
    "gtx.success": "Success",
    "gtx.failed": "Failed",
    "gtx.pending": "Pending",
    "gtx.debit": "Debit",
    "gtx.credit": "Credit",
    "gtx.allStatuses": "All statuses",
    "gtx.allTypes": "All types",
    "gtx.allRefunds": "All",
    "gtx.isRefund": "Refunds only",
    "gtx.notRefund": "Without refunds",
    "gtx.reset": "Reset",
    "gtx.empty": "No transactions found",
    "gtx.detailTitle": "Transaction details",
    "gtx.main": "General",
    "gtx.transaction": "Transaction",
    "gtx.money": "Money",
    "gtx.dates": "Dates",
    "gtx.number": "Transaction number",
    "gtx.round": "Round number",
    "gtx.session": "Session",
    "gtx.box": "Box",
    "gtx.admin": "Admin",
    "gtx.currency": "Currency",
    "gtx.rate": "Rate to USD",
    "gtx.createdAt": "Created",
    "gtx.updatedAt": "Updated",
    "gtx.result": "Result (operator response)",
    "gtx.noResult": "No operator response yet",
    "gtx.roundTransactions": "Round transactions",
    "gtx.tester": "Tester",
    "gtx.yes": "Yes",
    "gtx.no": "No",
    "gtx.includeTesters": "Include test players",
    "gtx.includeVips": "Include VIP players",
    "gtx.totalDebit": "Debit total",
    "gtx.totalCredit": "Credit total",
    "gtx.totalNet": "Net (Debit − Credit)",
    "gtx.summaryCount": "tx",

    /* GAME TRANSACTIONS — LIST */
    "gtx.filter": "Filter",
    "gtx.studio": "Studio",
    "gtx.operators": "Operators",
    "gtx.players": "Players",
    "gtx.noGame": "No game",
    "gtx.nothingFound": "Nothing found",
    "gtx.detailSubtitle": "What happened to the money",
    "gtx.copyNumber": "Copy the transaction number",
    "gtx.copied": "Number copied",
    "gtx.copyFailed": "Copy failed",
    "gtx.playerType": "Player type",
    "gtx.regular": "Regular",
    "gtx.ago": "Time passed",

    /* GAME TRANSACTIONS — NUMBERS */
    "gtx.total": "Transactions",
    "gtx.playersCount": "Players",
    "gtx.vipsCount": "VIP players",
    "gtx.failedCount": "Failed",
    "gtx.refundsCount": "Refunds",
    "gtx.netPositive": "in favour of the casino",
    "gtx.netNegative": "in favour of the players",

    /* GAME TRANSACTIONS — FILTER */
    "gtx.filterTitle": "Transactions filter",
    "gtx.filterSubtitle": "Period, status, operators and games",
    "gtx.period": "Period",
    "gtx.dateFrom": "Date from",
    "gtx.dateTo": "Date to",
    "gtx.searchByGame": "Table, slug or studio",
    "gtx.gamesEmpty": "No games available",
    "gtx.filterHint": "An empty selection means every available operator and game. Only what the token reaches is listed.",

    /* BONUS */
    "bns.title": "Bonus",
    "bns.search": "Player, game number, bonus number or combination",
    "bns.filter": "Filter",
    "bns.settings": "JACKPOT",
    "bns.player": "Player",
    "bns.game": "Game",
    "bns.games": "Games",
    "bns.studio": "Studio",
    "bns.operator": "Operator",
    "bns.operators": "Operators",
    "bns.players": "Players",
    "bns.bet": "Bet",
    "bns.win": "Win",
    "bns.jackpot": "JACKPOT",
    "bns.cash": "Cash box",
    "bns.date": "Date",
    "bns.tester": "Tester",
    "bns.round": "Round",
    "bns.gameNumber": "Game number",
    "bns.combination": "Combination",
    "bns.multiplier": "Multiplier",
    "bns.rate": "Rate to USD",
    "bns.result": "Result",
    "bns.allResults": "All rounds",
    "bns.onlyWins": "Wins only",
    "bns.onlyLoses": "No win",
    "bns.pools": "How the bet was split",
    "bns.poolBefore": "Before",
    "bns.poolShare": "Share of the bet",
    "bns.poolAfter": "After",
    "bns.noGame": "No game",
    "bns.empty": "No bonus bets yet",
    "bns.nothingFound": "Nothing found",
    "bns.detailTitle": "Bonus bet",
    "bns.detailWin": "Bonus win",
    "bns.copyNumber": "Copy the game number",
    "bns.copied": "Number copied",
    "bns.copyFailed": "Could not copy",

    /* BONUS — NUMBERS */
    "bns.total": "Bets",
    "bns.playersCount": "Players",
    "bns.winsCount": "Wins",
    "bns.gamesCount": "Games",
    "bns.maxWin": "Biggest win",
    "bns.totalBets": "Total bets",
    "bns.totalWins": "Total payouts",
    "bns.totalNet": "Difference (Bets − Payouts)",
    "bns.jackpotShare": "To JACKPOT:",
    "bns.summaryCount": "rounds",
    "bns.netPositive": "in favour of the casino",
    "bns.netNegative": "in favour of the players",

    /* BONUS — FILTER */
    "bns.filterTitle": "Bonus filter",
    "bns.filterSubtitle": "Period, result, operators and games",
    "bns.period": "Period",
    "bns.dateFrom": "Date from",
    "bns.dateTo": "Date to",
    "bns.includeTesters": "Include test players",
    "bns.includeVips": "Include VIP players",
    "bns.searchByGame": "Table, slug or studio",
    "bns.gamesEmpty": "No available games",
    "bns.filterHint": "An empty selection means every available operator and game. Only what the token reaches is listed.",
    "bns.reset": "Reset",

    /* BONUS — JACKPOT SETTINGS */
    "bns.jackpotTitle": "JACKPOT settings",
    "bns.jackpotSubtitle": "The prize pool and the cash box of every operator",
    "bns.jackpotTotal": "Total JACKPOT",
    "bns.cashTotal": "Total cash",
    "bns.connectedCount": "Connected",
    "bns.activeCount": "active:",
    "bns.statusActive": "Visible to players",
    "bns.statusDisabled": "Hidden",
    "bns.jackpotEmpty": "JACKPOT is not connected yet",
    "bns.jackpotEmptyText": "Connect JACKPOT to an operator — the prize pool starts growing from the bets of the players",
    "bns.connect": "Connect",
    "bns.jackpotHint": "Click an operator to change the amounts",
    "bns.updateSubtitle": "Prize pool, cash box and visibility",
    "bns.wasAmount": "Was:",
    "bns.visibility": "JACKPOT visibility",
    "bns.visibilityOn": "Players see the prize pool in the game",
    "bns.visibilityOff": "The prize pool is hidden from the players",
    "bns.connectTitle": "Connect JACKPOT",
    "bns.connectSubtitle": "Pick an operator and set the starting amounts",
    "bns.allPools": "All pools",
    "bns.testersOnly": "Testers only",
    "bns.testersOnlyOn": "Pool is in rollout: only test accounts bet and win",
    "bns.testersOnlyOff": "Normal mode: every player bets except test accounts",
    "bns.pool": "Jackpot pool",
    "bns.poolElectron": "Electronic games",
    "bns.poolLive": "Live games",
    "bns.startAmounts": "Starting amounts",
    "bns.selectOperator": "Pick an operator",
    "bns.operatorConnected": "Already connected",
    "bns.operatorFree": "Free",
    "bns.operatorsEmpty": "No operators",
    "bns.allConnected": "Every operator is already connected to JACKPOT",
    "bns.searchByOperator": "Search by operator name",

    /* LOGS */
    "log.title": "Logs",
    "log.game": "Game",
    "log.games": "Games",
    "log.studio": "Studio",
    "log.table": "Table slug",
    "log.type": "Type",
    "log.message": "Message",
    "log.date": "Date",

    /* LOGS LIST */
    "log.search": "Error text or table slug",
    "log.filter": "Filter",
    "log.total": "Records",
    "log.range": "Period",
    "log.lastRecord": "Last record",
    "log.cut": "text cut",
    "log.noMessage": "The message is empty",
    "log.noTable": "No table",
    "log.empty": "No logs yet",
    "log.nothingFound": "Nothing found",
    "log.copied": "Message copied",
    "log.copyFailed": "Copy failed",

    /* LOGS AGO */
    "log.ago.now": "just now",
    "log.ago.minutes": "min",
    "log.ago.hours": "h",
    "log.ago.days": "d",
    "log.ago.suffix": "ago",

    /* LOGS DETAIL MODAL */
    "log.detailTitle": "Log entry details",
    "log.information": "About the record",
    "log.copy": "Copy",
    "log.copyMessage": "Copy the message",
    "log.noStudio": "Unknown studio",
    "log.tableMissingHint": "This slug is gone from the tables — the table was renamed or deleted, the records stayed.",
    "log.repeats": "Repeats",
    "log.repeatsMany": "The message repeats",
    "log.repeatsOnce": "A single case",
    "log.repeatsOnceNote": "This message appears for the first time on this table",
    "log.repeatsFirst": "first",
    "log.repeatsLast": "last",
    "log.around": "Around on this table",
    "log.aroundEmpty": "No other records on this table",
    "log.before": "before",
    "log.after": "after",

    /* LOGS FILTER MODAL */
    "log.filterTitle": "Logs filter",
    "log.filterSubtitle": "Period, type and games",
    "log.period": "Period",
    "log.dateFrom": "Date from",
    "log.dateTo": "Date to",
    "log.allTypes": "All types",
    "log.searchByGame": "Table, slug or studio",
    "log.gamesEmpty": "No tables with logs",
    "log.gamesHint": "An empty selection means every game. The number next to a table is how many records it wrote.",
    "log.reset": "Reset",

    /* BOOKING PAGE */
    "book.title": "VIP table booking",
    "book.search": "Player, ID, comment or admin",
    "book.filter": "Filter",
    "book.create": "Book a table",
    "book.game": "Game",
    "book.games": "Games",
    "book.player": "Player",
    "book.playerID": "Player ID",
    "book.window": "Time",
    "book.status": "Status",
    "book.author": "Created by",
    "book.operator": "Operator",
    "book.operators": "Operators",
    "book.comment": "Comment",

    /* BOOKING TABS */
    "book.tab.upcoming": "Upcoming",
    "book.tab.history": "History",

    /* BOOKING STATES */
    "book.state.booked": "Booked",
    "book.state.soon": "Starts soon",
    "book.state.live": "Running now",
    "book.state.arrived": "Player arrived",
    "book.state.missed": "No-show",
    "book.state.cancelled": "Cancelled",

    /* BOOKING TIME */
    "book.today": "Today",
    "book.tomorrow": "Tomorrow",
    "book.yesterday": "Yesterday",
    "book.in": "in",
    "book.leftUntilEnd": "ends in",
    "book.ended": "ended",
    "book.ago": "ago",
    "book.cancelledAt": "cancelled",
    "book.unit.minutes": "min",
    "book.unit.hours": "h",
    "book.unit.days": "d",

    /* BOOKING EMPTY STATES */
    "book.noGame": "The game is gone",
    "book.noName": "Name unknown",
    "book.tester": "TEST",
    "book.nothingFound": "Nothing found",
    "book.noGames": "No VIP games",
    "book.noOperators": "No operators available",
    "book.emptyUpcoming": "No upcoming bookings",
    "book.emptyUpcomingNote": "Bookings whose window is still ahead appear here. Press “Book a table” to hold a VIP table for a player.",
    "book.emptyHistory": "The history is still empty",

    /* BOOKING FORM */
    "book.createTitle": "New booking",
    "book.createSubtitle": "Operator, player, VIP game and time",
    "book.createButton": "Create booking",
    "book.createdSuccess": "The booking is created",
    "book.selectOperatorFirst": "Choose an operator first — the list of VIP games depends on it",
    "book.searchByGame": "Table or studio",
    "book.checkingPlayer": "Checking the player ID…",
    "book.unknownPlayer": "No entrance of this ID is known yet. The booking can still be written, but read the ID once more.",
    "book.commentPlaceholder": "For example: the guest arrives with company, hold the table until 23:00",
    "book.lengthHint": "The table stays held for",
    "book.from": "From",
    "book.to": "To",

    /* BOOKING ACTIONS */
    "book.cancelTitle": "Cancel the booking",
    "book.cancelConfirm": "Cancel the booking?",
    "book.cancelButton": "Cancel the booking",
    "book.cancelledSuccess": "The booking is cancelled",
    "book.cancelArrivedNote": "the player is already in the game",
    "book.cancelLiveNote": "the window is running right now",

    /* BOOKING WINDOW MODAL */
    "book.windowTitleAction": "Change the time",
    "book.windowTitle": "Time of the booking",
    "book.windowSubtitle": "Extend or shorten it — the game and the player stay the same",
    "book.windowButton": "Save the time",
    "book.windowSuccess": "The time of the booking is changed",
    "book.was": "Was",
    "book.becomes": "Becomes",

    /* BOOKING FILTER MODAL */
    "book.filterTitle": "Bookings filter",
    "book.filterSubtitle": "Period, status, operators and games",
    "book.filterHint": "An empty selection means every VIP game of your access.",
    "book.allStatuses": "All statuses",
    "book.reset": "Reset",
    "book.period.title": "Period",
    "book.period.today": "Today",
    "book.period.tomorrow": "Tomorrow",
    "book.period.yesterday": "Yesterday",
    "book.period.next7days": "Next 7 days",
    "book.period.last7days": "Last 7 days",
    "book.period.thisMonth": "This month",
    "book.period.prevMonth": "Previous month",
    "book.period.all": "All time",

    /* BOOKING ERRORS */
    "book.error.selectOperator": "Choose an operator",
    "book.error.emptyPlayer": "Enter the player ID",
    "book.error.selectGame": "Choose a VIP game",
    "book.error.selectWindow": "Set the time of the booking",
    "book.error.wrongWindow": "The end has to be later than the start",
    "book.error.sameWindow": "The time of the booking has not changed",

}

export default en
